import RelationshipMetadata from "../../RelationshipMetadata";

class EnterpriseTermRevisionTermSynonymRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "EnterpriseTermRevisionTermSynonym";
        this.parentEnterpriseComponent = "EnterpriseTermRevision";
        this.childEnterpriseComponent = "TermSynonym";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "TermUSID";
    }
}

export default EnterpriseTermRevisionTermSynonymRelationshipMetadata;
